import React from 'react';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';

/* 	InputField
 *	@params id 			string	 	identificador input
 * 	@params label 		string  	label input
 *	@params value		any type	value input
 *	@params disabled	bool		disabled input
 *	@params error		bool 		enable class error
 *	@params helperText	string 		helper text
 *	@params onChange	function 	function change
 *	@params InputProps	Object
 *	More Information https://material-ui.com/es/api/text-field/
 */
const InputField = ({
  id,
  label,
  type,
  name,
  placeholder,
  value,
  error,
  disabled,
  readOnly,
  helperText,
  onBlur,
  onChange,
  onPaste,
  InputProps,
  multiline
}) => (
  <FormControl fullWidth>
    <TextField
      variant='standard'
      fullWidth
      id={id}
      error={!!error}
      multiline={multiline}
      label={label}
      name={name}
      value={value}
      placeholder={placeholder}
      helperText={helperText}
      onChange={onChange}
      onPaste={onPaste}
      onBlur={onBlur}
      disabled={disabled}
      inputProps={{
        ...InputProps,
        readOnly,
        type,
        className: 'underline'
      }}
    />
  </FormControl>
);
export default InputField;
